//메모 memo
export const needTag = ["XRP", "EOS", "HBAR", "ATOM", "HIVE", "KAVA", "SCRT", "XLM",  "BAND", "STX"];
export const isNeedTag = (coinCode) => {
    if (needTag.find((need) => need == coinCode)) return true;
    else return false;
};
